import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import ListPageHeader from "@client/components/containers/ListPageHeader";
import ListPageNavigation from "@client/components/modules/ListPage/Navigation/ListPageNavigation";
import userStore from "@client/stores/LicensorStore";
import Style from "@client/utils/Style";

const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;
const Navigation = styled.div`
  display: flex;
  ${Style.exactWidth("320px")}
`;
const Content = styled.div`
  padding: 0 64px 0 64px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
`;
const List = styled.div<{ noMargin?: boolean }>`
  margin-left: ${(props: any) => (props.noMargin ? "0" : "-32px")};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
const Header = styled.div`
  min-width: 800px;
`;
const Footer = styled.div`
  flex-shrink: 0;
  padding: 16px 0;
  color: ${Style.palette.grayscale[4]};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type Props = {
  title: string;
  listComponent: React.ReactNode;
  listNoMargin?: boolean;
  footerText: string;
  footerComponent?: React.ReactNode;
  pageHeaderRef?: (ref: typeof ListPageHeader) => void;
};
@observer
class ListTemplate extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        <Navigation>
          <ListPageNavigation tokenInfo={userStore.tokenInfo} />
        </Navigation>
        <Content>
          <Header>
            <ListPageHeader
              componentRef={this.props.pageHeaderRef}
              onNavigate={(path: string) => {
                if (path === "/") {
                  window.location.href = "/";
                } else {
                  window.history.pushState({}, "", path);
                }
              }}
              title={this.props.title}
            />
          </Header>
          <List noMargin={this.props.listNoMargin}>
            {this.props.listComponent}
          </List>
          <Footer>
            <div>{this.props.footerText}</div>
            <div
              style={{ flexGrow: 1, display: "flex", justifyContent: "center" }}
            >
              {this.props.footerComponent}
            </div>
          </Footer>
        </Content>
      </Wrapper>
    );
  }
}

export default ListTemplate;
